import { type ChangeEvent, type KeyboardEvent, useState } from 'react';
import { connect } from 'react-redux';
import { Key } from 'ts-keycode-enum';

import type { AccommodationState } from '@/interfaces';
import { actions as filterActions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';

export interface KeywordFilterProps {
    hotelName: string;
    filterByHotelName: (hotelName: string) => void;
    triggerFetch: () => void;
}

export const KeywordFilter = ({ hotelName, filterByHotelName, triggerFetch }: KeywordFilterProps) => {
    const [value, setValue] = useState(hotelName);
    const [edited, setEdited] = useState(false);

    const onChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setValue(event.target.value);
        setEdited(true);
    };

    const onConfirm: () => void = (): void => {
        if (edited) {
            if (value?.length) {
                filterByHotelName(value);
            } else {
                filterByHotelName(undefined);
            }
            triggerFetch();
        }
        setEdited(false);
    };

    const onKeyDown = (event: KeyboardEvent): void => {
        if ((event.which || event.keyCode) === Key.Enter) {
            onConfirm();
        }
    };

    return (
        <div id="HotelNameFilter" className="input input--search u-mv32" data-testid="keywordSearchFilter">
            <label htmlFor="keywordFilter" className="u-screen-reader-only">
                Hotellnavnet inneholder
            </label>
            <input
                type="search"
                id="keywordFilter"
                data-testid="keywordFilter"
                maxLength={100}
                onChange={onChange}
                onBlur={onConfirm}
                onKeyDown={onKeyDown}
                defaultValue={hotelName}
            />
            <button
                type="button"
                aria-label="Søk"
                className="input--search__button input--search__button--submit keyword-search-button u-hide-lt768"
                id="keywordButton"
                data-testid="keywordFilterButton"
                onClick={onConfirm}
            />
        </div>
    );
};

const mapStateToProps = (state: AccommodationState): Pick<KeywordFilterProps, 'hotelName'> => ({
    hotelName: state.filters.hotelName,
});

const mapDispatchToProps = { filterByHotelName: filterActions.filterByHotelName, triggerFetch: fetchHotels };

export default connect(mapStateToProps, mapDispatchToProps)(KeywordFilter);
